import { getItem, setItem } from "./safe-storage.js";

// 1. Parse active incoming browser credentials
const urlParams = new URLSearchParams(window.location.search);
let initialUid = urlParams.get("userId");
let initialNickname = urlParams.get("nickname");
let initialSpaceId = urlParams.get("spaceId");
let initialMapId = urlParams.get("mapId");

// Helper functions to manage cookie strings manually
function setCookie(name, value, days) {
  try {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/; SameSite=Strict; Secure`;
  } catch {
    // Sandboxed / opaque origins may block cookies
  }
}

function getCookie(name) {
  try {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
  } catch {
    // ignore
  }
  return null;
}

// 2. Run your verified cookie evaluation matrix
if (initialUid) {
  setItem("w2l_uid", initialUid);
  setCookie("w2l_uid", initialUid, 365);
  setItem("w2l_nickname", initialNickname);
  setCookie("w2l_nickname", initialNickname, 365);
} else {
  initialUid = getCookie("w2l_uid") || getItem("w2l_uid");
  initialNickname = getCookie("w2l_nickname") || getItem("w2l_nickname");
}

if (initialSpaceId) {
  setItem("w2l_space_id", initialSpaceId);
  setCookie("w2l_space_id", initialSpaceId, 365);
} else {
  initialSpaceId = getCookie("w2l_space_id") || getItem("w2l_space_id");
}

if (initialMapId) {
  setItem("w2l_map_id", initialMapId);
  setCookie("w2l_map_id", initialMapId, 365);
} else {
  initialMapId = getCookie("w2l_map_id") || getItem("w2l_map_id");
}

// 3. Export the final authenticated ID so the rest of the app can use it instantly
export const userId = initialUid;
export const nickname = initialNickname;
export const spaceId = initialSpaceId;
export const mapId = initialMapId;
